export type Certification = {
  activeDate: string | null;
  expireDate: string | null;
  id: string;
  imageUrl: string | null;
  name: string | null;
  nameAbbr: string | null;
  publicUrl: string | null;
  status: string | null;
};

export function processCertifications(
  certifications: (Certification | null)[],
  removeEmeritus: boolean,
): Certification[] {
  const currentDate = new Date();
  // Filter out null values
  const nonNullCertifications = certifications.filter(
    (cert): cert is Certification => cert !== null,
  );
  // Filter out expired certifications
  const filteredCertifications = nonNullCertifications.filter(
    (certification) => {
      if (certification.expireDate) {
        const expireDate = new Date(certification.expireDate);
        return expireDate >= currentDate;
      }
      return true;
    },
  );
  // Remove 'Emeritus' from the name if removeEmeritus is true
  const updatedCertifications = filteredCertifications.map((certification) => {
    if (
      removeEmeritus &&
      certification.name &&
      certification.name.includes('Emeritus')
    ) {
      return {
        ...certification,
        name: certification.name.replace('Emeritus', '').trim(),
      };
    }
    return certification;
  });
  // Sort certifications
  updatedCertifications.sort((a, b) => {
    const isExpertA = a.name?.startsWith('Atlassian Certified Expert') || false;
    const isExpertB = b.name?.startsWith('Atlassian Certified Expert') || false;
    if (isExpertA && !isExpertB) {
      return -1;
    }
    if (!isExpertA && isExpertB) {
      return 1;
    }
    return (
      new Date(b.activeDate ?? 0).getTime() -
      new Date(a.activeDate ?? 0).getTime()
    );
  });
  return updatedCertifications;
}
